/**
 * Load an external script.
 *
 * @param {string} url Absolute URL of script to load
 * @param {string=} name Name of global variable that the script is expected to define
 * @return {Promise}
 */
export const loadScript = (url, name, domElement) => {
    const documentRef = domElement.ownerDocument;

    const promise = new Promise((resolve, reject) => {
        const script = documentRef.createElement("script");
        script.onerror = () => reject(new Error(`Failed to load '${url}'`));
        script.onload = resolve;
        script.async = true;
        script.src = url;

        if (documentRef.currentScript) {
            documentRef.currentScript.parentNode.insertBefore(script, documentRef.currentScript);
        } else {
            (documentRef.head || documentRef.getElementsByTagName("head")[0]).appendChild(script);
        }
    });

    return promise.then(event => {
        // event.target.parentNode.removeChild(event.target);
        if (event.target.ownerDocument.defaultView[name]) {
            return event.target.ownerDocument.defaultView[name];
        }
        throw new Error(`"${name}" was not created by "${url}"`);
    });
};
export default loadScript;
